import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { AppShell } from './components/AppShell';
import { AdminScreen } from './screens/AdminScreen';
import { Spinner } from './components/ui';
import { BoardScreen } from './screens/BoardScreen';
import { ChatListScreen } from './screens/ChatListScreen';
import { ChatRoomScreen } from './screens/ChatRoomScreen';
import { FavoritesScreen } from './screens/FavoritesScreen';
import { HarvestScreen } from './screens/HarvestScreen';
import { InfoScreen } from './screens/InfoScreen';
import { LoginScreen } from './screens/LoginScreen';
import { OnboardingScreen } from './screens/OnboardingScreen';
import { PostDetailScreen } from './screens/PostDetailScreen';
import { PostEditorScreen } from './screens/PostEditorScreen';
import { PublicPostScreen } from './screens/PublicPostScreen';
import { SettingsScreen } from './screens/SettingsScreen';
import { WelcomeScreen } from './screens/WelcomeScreen';
import { captureRefFromUrl } from './lib/referral';
import { useSessionStore } from './store/session';

/**
 * 인증 게이트가 라우터보다 바깥에 있다.
 * 로그인/온보딩은 URL을 갖지 않는다 — 상태가 곧 화면이고, 주소로 건너뛸 수 있으면 안 된다.
 */
export function App() {
  const status = useSessionStore((s) => s.status);
  const onboarded = useSessionStore((s) => s.onboarded);
  const justOnboarded = useSessionStore((s) => s.justOnboarded);
  const load = useSessionStore((s) => s.load);

  useEffect(() => {
    // 초대 링크(?ref=)로 왔으면 코드를 저장해두고 주소를 정리한다(세션 복구보다 먼저).
    captureRefFromUrl();
    void load();
  }, [load]);

  if (status === 'loading') {
    return (
      <div className="flex min-h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (status === 'anonymous') {
    // 공유 링크(/posts/:id)로 온 로그아웃 방문자는 로그인 대신 프리뷰를 보여준다.
    const shared = window.location.pathname.match(/^\/posts\/([0-9a-fA-F-]{16,})$/);
    if (shared) return <PublicPostScreen postId={shared[1]!} />;
    return <LoginScreen />;
  }
  if (!onboarded) return <OnboardingScreen />;
  // 방금 가입을 마쳤으면 환영 화면(패스키·홈 화면 추가·친구 초대 안내)을 1회 띄운다.
  if (justOnboarded) return <WelcomeScreen />;

  return (
    <BrowserRouter>
      <AppShell>
        <Routes>
          <Route path="/" element={<Navigate to="/market" replace />} />
          <Route path="/:slug" element={<BoardScreen />} />
          <Route path="/:slug/write" element={<PostEditorScreen />} />
          <Route path="/posts/:id" element={<PostDetailScreen />} />
          <Route path="/posts/:id/edit" element={<PostEditorScreen />} />
          <Route path="/favorites" element={<FavoritesScreen />} />
          <Route path="/harvest" element={<HarvestScreen />} />
          <Route path="/chats" element={<ChatListScreen />} />
          <Route path="/chats/:roomId" element={<ChatRoomScreen />} />
          <Route path="/admin" element={<AdminScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />
          <Route path="/about" element={<InfoScreen />} />
          <Route path="*" element={<Navigate to="/market" replace />} />
        </Routes>
      </AppShell>
    </BrowserRouter>
  );
}
